export const whatsNewEntries = [
  {
    id: "2026-09-betty-entwickelt-sich-weiter",
    publishedAt: "2026-09-05",

    title: {
      de: "betty entwickelt sich weiter",
      en: "betty keeps evolving",
    },

    shortText: {
      de:
        "In den vergangenen Wochen haben wir vor allem an der Stabilität und Zuverlässigkeit von betty gearbeitet. Viele Abläufe und Dialoge wurden erweitert und robuster gemacht, gleichzeitig wurden Datenhaltung und Berechnungen an zahlreichen Stellen verbessert.",
      en:
        "Over the past few weeks, we have focused primarily on betty's stability and reliability. Many workflows and dialogs have been expanded and made more robust, while data handling and calculations have improved in numerous areas.",
    },

    body: {
      de:
        "Besonders gewachsen ist die Liga-Auswahl: Neben der Tagesauswahl kann inzwischen Liga für Liga gearbeitet werden, mit einem besseren Überblick über Saison, Spieltage, Spiele und Statistiken. Auch Real-, Expected- und Should-Werte sowie weitere Vergleichswerte und Informationen wurden erheblich erweitert. Tooltips, Hilfe und kontextbezogene Erklärungen werden weiter ausgebaut. betty wird kontinuierlich weiterentwickelt – mit dem Schwerpunkt, die vorhandenen Funktionen immer stabiler, nachvollziehbarer und im täglichen Einsatz brauchbarer zu machen.",
      en:
        "The league view has grown in particular: alongside the daily selection, you can now work league by league with a clearer overview of seasons, matchdays, fixtures and statistics. Actual, Expected and Should values, as well as other comparisons and information, have also expanded significantly. Tooltips, help and contextual explanations will continue to improve. betty is evolving continuously, with a focus on making existing features increasingly stable, understandable and useful in everyday work.",
    },

    helpTarget: null,
  },

  {
    id: "2026-08-simulation",
    publishedAt: "2026-08-23",

    title: {
      de: "Simulation",
      en: "Simulation",
    },

    shortText: {
      de:
        "Simuliere mögliche Saisonverläufe und Wahrscheinlichkeiten auf Grundlage deiner Team Settings und Season Parameters.",
      en:
        "Simulate possible season outcomes and probabilities based on your Team Settings and Season Parameters.",
    },

    body: {
      de:
        "Die Algorithmen der Simulation sind klar definiert. Die zugrunde liegenden Einschätzungen bleiben bewusst veränderbar: Für die Spielstärke einer Mannschaft gibt es nicht die eine objektiv richtige Zahl. betty zeigt, welche Wahrscheinlichkeiten und Saisonverläufe aus deinen Einstellungen folgen.",
      en:
        "The simulation algorithms are clearly defined. The underlying assessments deliberately remain adjustable: there is no single objectively correct number for a team's strength. betty shows which probabilities and season outcomes follow from your settings.",
    },

    helpTarget: "simulation",
  },

  {
    id: "2026-08-expected-should-tables",
    publishedAt: "2026-08-23",

    title: {
      de: "Expected Table & Should Table",
      en: "Expected Table & Should Table",
    },

    shortText: {
      de:
        "Vergleiche Actual, Expected und Should und betrachte Ergebnis, Erwartung und Leistung aus unterschiedlichen Perspektiven.",
      en:
        "Compare Actual, Expected and Should to view results, expectations and performance from different perspectives.",
    },

    body: {
      de:
        "Die drei Tabellenansichten machen Abweichungen zwischen tatsächlichem Ergebnis, vorheriger Erwartung und statistisch gemessener Leistung sichtbar.",
      en:
        "The three table views reveal differences between actual results, prior expectations and statistically measured performance.",
    },

    helpTarget: "expectedVsActual",
  },

  {
    id: "2026-08-should-goals",
    publishedAt: "2026-08-23",

    title: {
      de: "Should Goals",
      en: "Should Goals",
    },

    shortText: {
      de:
        "Should Goals betrachten die Leistung anhand der Spielstatistiken – unabhängig davon, was tatsächlich auf der Anzeigetafel stand.",
      en:
        "Should Goals evaluate performance from match statistics, independently of what actually appeared on the scoreboard.",
    },

    body: {
      de:
        "Damit entsteht neben dem tatsächlichen Ergebnis und der vorherigen Erwartung eine weitere Vergleichsgröße für die Beurteilung einer Mannschaft.",
      en:
        "This adds another basis for assessing a team alongside the actual result and the prior expectation.",
    },

    helpTarget: "shouldGoals",
  },

  {
    id: "2026-08-table-stats",
    publishedAt: "2026-08-23",

    title: {
      de: "Table Stats erweitert",
      en: "Expanded Table Stats",
    },

    shortText: {
      de:
        "Tabellen, Durchschnittswerte und statistische Vergleichsmöglichkeiten wurden deutlich erweitert.",
      en:
        "Tables, averages and statistical comparison options have been significantly expanded.",
    },

    body: {
      de:
        "Table Stats entwickelt sich zum zentralen Bereich für den Vergleich von Actual, Expected, Should und weiteren statistischen Sichtweisen.",
      en:
        "Table Stats is becoming the central area for comparing Actual, Expected, Should and other statistical perspectives.",
    },

    helpTarget: "tableStats",
  },

  {
    id: "2026-08-evaluation",
    publishedAt: "2026-08-23",

    title: {
      de: "Evaluation verbessert",
      en: "Improved Evaluation",
    },

    shortText: {
      de:
        "Die Evaluation gibt jetzt klarere Rückmeldungen über die Auswertung und weist auf fehlende Expected- und Should-Daten hin.",
      en:
        "Evaluation now provides clearer feedback about the process and identifies missing Expected and Should data.",
    },

    body: {
      de:
        "Zusätzliche Hinweise und Details machen besser nachvollziehbar, was bei einer Evaluation verarbeitet wurde und wo noch Daten ergänzt werden können.",
      en:
        "Additional information and details make it easier to understand what was processed during an evaluation and where data can still be completed.",
    },

    helpTarget: "evaluate",
  },

  {
    id: "2026-08-help",
    publishedAt: "2026-08-23",

    title: {
      de: "Neue Hilfe",
      en: "New Help",
    },

    shortText: {
      de:
        "Die Hilfe verbindet allgemeine Erklärungen mit situationsbezogenen Begriffserklärungen direkt in betty.",
      en:
        "Help now combines general explanations with contextual explanations of terms directly inside betty.",
    },

    body: {
      de:
        "Fachbegriffe können direkt dort erklärt werden, wo sie auftauchen. Mehr erfahren führt von der kurzen Erklärung in den ausführlichen Hilfebereich.",
      en:
        "Technical terms can be explained where they appear. Read more leads from the short explanation to the detailed help section.",
    },

    helpTarget: null,
  },

  {
    id: "2026-08-compile",
    publishedAt: "2026-08-23",

    title: {
      de: "Compile verbessert",
      en: "Improved Compile",
    },

    shortText: {
      de:
        "Compile geht robuster mit fehlenden Teamdaten um und unterstützt das gezielte Nachkompilieren.",
      en:
        "Compile handles missing team data more robustly and supports targeted recompilation.",
    },

    body: {
      de:
        "Fehlende Voraussetzungen sollen den Ablauf nicht unnötig abbrechen. betty kann notwendige Ergänzungen erkennen und bestehende Daten gezielt nachkompilieren.",
      en:
        "Missing prerequisites should no longer interrupt the process unnecessarily. betty can identify required additions and selectively recompile existing data.",
    },

    helpTarget: "compile",
  },

  {
    id: "2026-08-plans",
    publishedAt: "2026-08-23",

    title: {
      de: "Plans & Upgrade",
      en: "Plans & Upgrade",
    },

    shortText: {
      de:
        "Die verfügbaren Pläne bestimmen, welche Ligen du in betty nutzen kannst. Die Funktionen selbst stehen grundsätzlich in allen Plänen zur Verfügung.",
      en:
        "Your plan determines which leagues you can use in betty. The available features are generally the same across all plans.",
    },

    body: {
      de:
        "Der Bereich für Pläne und Upgrades soll verständlicher zeigen, welche Ligen mit dem aktuellen Plan verfügbar sind und welche zusätzlichen Ligen ein Upgrade freischaltet.",
      en:
        "The plans and upgrade area is intended to show more clearly which leagues are available with the current plan and which additional leagues an upgrade unlocks.",
    },

    helpTarget: null,
  },
];


export function getLatestWhatsNewEntry() {
  return whatsNewEntries[0] || null;
}


export function getWhatsNewEntry(id) {
  return (
    whatsNewEntries.find(
      (entry) =>
        entry.id === id
    ) || null
  );
}


export function hasUnseenWhatsNew(
  lastSeenWhatsNew
) {
  const latest =
    getLatestWhatsNewEntry();

  if (!latest) {
    return false;
  }

  return (
    latest.id !==
    lastSeenWhatsNew
  );
}


export async function persistWhatsNewView(
  latestEntry,
  lastSeenWhatsNew,
  saveSeen
) {
  if (
    !latestEntry ||
    latestEntry.id === lastSeenWhatsNew
  ) {
    return lastSeenWhatsNew ?? null;
  }

  await saveSeen(latestEntry.id);
  return latestEntry.id;
}


export function getWhatsNewText(
  entry,
  field,
  language = "en"
) {
  if (!entry?.[field]) {
    return "";
  }

  const resolvedLanguage =
    String(language)
      .toLowerCase()
      .startsWith("de")
      ? "de"
      : "en";

  return (
    entry[field][resolvedLanguage] ||
    entry[field].en ||
    entry[field].de ||
    ""
  );
}
